import { createSlice } from "@reduxjs/toolkit";
import { appStorageKey, tenant } from "../utils/global";

const safeParse = (value) => {
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
};

const getStoredCompany = () => {
    const storedCompany = safeParse(localStorage.getItem(appStorageKey('selectedCompany')));
    const firstCompany = tenant()?.companies?.[0];
    const langFromI18n = String(localStorage.getItem('i18nextLng') || '').toLowerCase().startsWith('ar') ? 'ar' : 'en';
    const defaultLangFromSettings =
      firstCompany?.settings?.generalSettings?.find?.((s) => s?.name === 'DEFAULT_LANG')?.value ||
      firstCompany?.settings?.generalSettings?.find?.((s) => s?.settingName === 'DEFAULT_LANG')?.value;
    const desiredLang = (defaultLangFromSettings || langFromI18n || 'en').toLowerCase().startsWith('ar') ? 'ar' : 'en';
    if (storedCompany?.value) {
        const storedCompanyEntity = tenant()?.companies?.find((company) => company?._id === storedCompany?.value);
        const storedCompanyName =
          storedCompanyEntity?.name?.find?.((n) => n?.lang === desiredLang)?.text ||
          storedCompanyEntity?.name?.find?.((n) => n?.lang === 'ar')?.text ||
          storedCompanyEntity?.name?.find?.((n) => n?.lang === 'en')?.text ||
          storedCompanyEntity?.name?.[0]?.text ||
          storedCompany?.name;
        return {
            name: storedCompanyName || storedCompany?.name,
            value: storedCompany?.value
        };
    }
    return {
        name:
          firstCompany?.name?.find?.((n) => n?.lang === desiredLang)?.text ||
          firstCompany?.name?.find?.((n) => n?.lang === 'ar')?.text ||
          firstCompany?.name?.find?.((n) => n?.lang === 'en')?.text ||
          firstCompany?.name?.[0]?.text ||
          (desiredLang === 'ar' ? 'الشركة' : 'Select a company'),
        value: firstCompany?._id,
    };
};

const initialState = getStoredCompany();

const currentCompanySlice = createSlice({
    name: 'currentCompany',
    initialState,
    reducers:{
        setCurrentCompany: (state,action) => {
            state.name = action.payload.name;
            state.value = action.payload.value;
            state.updatedAt = Date.now();
            localStorage.setItem(appStorageKey('selectedCompany'), JSON.stringify({
                name: action.payload.name,
                value: action.payload.value,
                updatedAt: state.updatedAt
            }));
        }
    },
});

export const {setCurrentCompany} = currentCompanySlice.actions;
export default currentCompanySlice.reducer
